import React, { useState, useEffect } from "react";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import axios from "axios";
import { OrbitProgress } from "react-loading-indicators";
import { useConfigQuery } from "../../../../queries/useConfig";

const RelatorioVendedor = ({ status, type }) => {
  const { data: config, error } = useConfigQuery();
  const [loja, setLoja] = useState(null);
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);

  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalProdutos, setTotalProdutos] = useState(0);
  const [valorTotalEstoque, setValorTotalEstoque] = useState(0);
  const [bloPDF, setBloPDF] = useState(1);

  useEffect(() => {
    if (accessToken && idUser) {
      axios
        .get(`https://techfood-api.herokuapp.com/v1/restaurantes/usuario/${idUser}`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((response) => setLoja(response.data))
        .catch((error) => console.error("Erro ao buscar loja:", error));
    }
  }, [idUser, accessToken]);

  const fetchData = async (periodo, pageNumber = 0) => {
    setTotalProdutos(0);
    setValorTotalEstoque(0);
    setIsLoading(true);

    let dataInicio, dataFim;
    const currentDate = new Date();

    switch (periodo) {
      case "hoje":
        dataInicio = currentDate.toISOString().split("T")[0];
        dataFim = dataInicio;
        break;
      case "ontem":
        const ontem = new Date();
        ontem.setDate(ontem.getDate() - 1);
        dataInicio = ontem.toISOString().split("T")[0];
        dataFim = dataInicio;
        break;
      case "semana":
        dataInicio = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay()))
          .toISOString()
          .split("T")[0];
        dataFim = new Date().toISOString().split("T")[0];
        break;
      case "custom":
        dataInicio = startDate.toISOString().split("T")[0];
        dataFim = endDate.toISOString().split("T")[0];
        break;
      default:
        return;
    }
    
    setStartDate(new Date(dataInicio));
    setEndDate(new Date(dataFim));

    console.log("Datas:", dataInicio, dataFim);
    console.log("Página:", pageNumber);

    if (loja && accessToken) {
      try {
        // URL com o novo endpoint e formato Page
        const url = `https://techspdv-api-d3e739785e34.herokuapp.com/v1/pdveventos/listarPorDataeStatusOrdenarPorVendedor/${loja.id}/${dataInicio}/${dataFim}/${type}/${config?.tpAmb}/${status}?page=${pageNumber}&size=20`;
        
        console.log("URL da requisição:", url);
        
        const response = await axios.get(url, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });
        
        console.log("Resposta completa:", response.data);
        
        // MUDANÇA: Agora pega de "content" em vez de "_embedded.PDVEvento"
        setData(response.data?.content || []);
        
        // MUDANÇA: Paginação direta do objeto Page
        setTotalPages(response.data?.totalPages || 1);
        setCurrentPage(response.data?.number || 0);
        
        // Busca totais
        await fetchAllDataTotal(dataInicio, dataFim);
        setBloPDF(0);
        
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
        setData([]);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const fetchAllDataTotal = async (dataInicio, dataFim) => {
    let valorTotalTemp = 0;
    let totalElementsTemp = 0;

    setIsLoading(true);

    try {
      const url = `https://techspdv-api-d3e739785e34.herokuapp.com/v1/pdveventos/periodotiposttsTOTAISSUM/${loja.id}/${dataInicio}/${dataFim}/${type}/${config?.tpAmb}/${status}?page=0&size=20`;
      
      const response = await axios.get(url, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      
      console.log("Totais:", response.data);
      valorTotalTemp = response.data.valorTotal;
      totalElementsTemp = response.data.totalPedidos;
      setTotalProdutos(totalElementsTemp);
      setValorTotalEstoque(valorTotalTemp);

    } catch (error) {
      console.error("Erro ao buscar totais:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllData = async () => {
    const dataInicioAux = startDate.toISOString().split("T")[0];
    const dataFimAux = endDate.toISOString().split("T")[0];

    let allData = [];
    let page = 0;
    let hasMorePages = true;

    setIsLoading(true);

    try {
      while (hasMorePages) {
        const url = `https://techspdv-api-d3e739785e34.herokuapp.com/v1/pdveventos/listarPorDataeStatusOrdenarPorVendedor/${loja.id}/${dataInicioAux}/${dataFimAux}/${type}/${config?.tpAmb}/${status}?page=${page}&size=20`;

        const response = await axios.get(url, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });

        // MUDANÇA: pega de content
        const fetchedData = response.data?.content || [];
        allData = [...allData, ...fetchedData];
        
        // Verifica se tem mais páginas
        hasMorePages = page < (response.data?.totalPages - 1);
        page++;
      }

      return allData;
    } catch (error) {
      console.error("Erro ao buscar todos os dados:", error);
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  const groupByVendedor = (data) => {
    return data.reduce((acc, item) => {
      const vendedorKey = item.nomeVendedor || item.idVendedor || "SEM_VENDEDOR";

      if (!acc[vendedorKey]) {
        acc[vendedorKey] = [];
      }

      acc[vendedorKey].push(item);
      return acc;
    }, {});
  };

  const generatePDF = async () => {
    const allData = await fetchAllData();
    if (!allData || !allData.length) return;

    // Agrupa por vendedor
    const dadosPorVendedor = groupByVendedor(allData);

    // Gera um PDF para cada vendedor
    Object.entries(dadosPorVendedor).forEach(([idVendedor, vendas]) => {
      const doc = new jsPDF();

      doc.text(`Relatório de Vendas - Vendedor ${idVendedor}`, 14, 10);

      const totalValor = vendas.reduce(
        (sum, item) => sum + Number(item.valorTotalLiquido || 0),
        0
      );

      doc.text(`Total Vendas: ${vendas.length}`, 14, 20);
      doc.text(
        `Total Valor: R$ ${totalValor.toFixed(2).replace(".", ",")}`,
        14,
        30
      );

      const tableData = vendas.map((item) => [
        item.numeroDocFiscal || "-",
        item.dataHoraAbertura
          ? new Date(item.dataHoraAbertura).toLocaleString("pt-BR")
          : "-",
        item.cpf || "-",
        `R$ ${parseFloat(item.valorTotalLiquido)
          .toFixed(2)
          .replace(".", ",")}`,
      ]);

      doc.autoTable({
        head: [["Pedido/Nota", "Data/Hora", "Consumidor", "Valor (R$)"]],
        body: tableData,
        startY: 40,
      });

      doc.save(`relatorio_vendedor_${idVendedor.replace(/\s+/g, '_')}.pdf`);
    });
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      fetchData("custom", newPage);
    }
  };

  return (
    <div style={{ width: "80%", margin: "0 auto" }}>
      <h2>Relatório por Vendedor</h2>

      <div style={{ marginBottom: "20px", textAlign: "center" }}>
        {/* Botões para selecionar períodos */}
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
          <button
            style={{
              backgroundColor: loja?.id ? "black" : "grey",
              color: "#fff",
              padding: "10px 20px",
              cursor: loja?.id ? "pointer" : "not-allowed",
              border: "none",
              borderRadius: "5px",
            }}
            disabled={!loja?.id}
            onClick={() => fetchData("hoje")}
          >
            Hoje
          </button>
          <button
            style={{
              backgroundColor: loja?.id ? "black" : "grey",
              color: "#fff",
              padding: "10px 20px",
              cursor: loja?.id ? "pointer" : "not-allowed",
              border: "none",
              borderRadius: "5px",
            }}
            disabled={!loja?.id}
            onClick={() => fetchData("ontem")}
          >
            Ontem
          </button>
          <button
            style={{
              backgroundColor: loja?.id ? "black" : "grey",
              color: "#fff",
              padding: "10px 20px",
              cursor: loja?.id ? "pointer" : "not-allowed",
              border: "none",
              borderRadius: "5px",
            }}
            disabled={!loja?.id}
            onClick={() => fetchData("semana")}
          >
            Semana
          </button>
          
          {/* Campos de data */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ marginRight: "10px" }}>
              <strong>Início:</strong>
              <input
                type="date"
                value={
                  startDate instanceof Date && !isNaN(startDate.getTime())
                    ? startDate.toISOString().split("T")[0]
                    : ""
                }
                onChange={(e) => setStartDate(new Date(e.target.value))}
                style={{ marginLeft: "5px", padding: "5px" }}
              />
            </div>
            <div>
              <strong>Fim:</strong>
              <input
                type="date"
                value={
                  endDate instanceof Date && !isNaN(endDate.getTime())
                    ? endDate.toISOString().split("T")[0]
                    : ""
                }
                onChange={(e) => setEndDate(new Date(e.target.value))}
                style={{ marginLeft: "5px", padding: "5px" }}
              />
            </div>
            
            {/* Botão de Buscar */}
            <button
              style={{
                backgroundColor: loja?.id ? "black" : "grey",
                color: "#fff",
                padding: "10px 20px",
                cursor: loja?.id ? "pointer" : "not-allowed",
                border: "none",
                borderRadius: "5px",
                marginLeft: "10px",
              }}
              onClick={() => fetchData("custom")}
              disabled={!loja?.id}
            >
              Buscar
            </button>
          </div>
        </div>

        {/* Exibição do total de produtos e total valor */}
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px", alignItems: "center" }}>
          <div>
            <strong>Total de Pedidos:</strong> {totalProdutos}
          </div>
          
          {bloPDF ? (
            <div></div>
          ) : (
            <button
              style={{
                backgroundColor: "black",
                color: "#fff",
                padding: "8px 16px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
              onClick={generatePDF}
            >
              Gerar PDF
            </button>
          )}

          <div>
            <strong>Total Valor:</strong> R$ {valorTotalEstoque.toFixed(2).replace(".", ",")}
          </div>
        </div>

        {isLoading ? (
          <div className="loading">
            <OrbitProgress variant="spokes" color="#646464" size="large" />
            <div className="loading-text" style={{ color: "#646464", fontSize: "18px", textAlign: "center", fontWeight: "bold" }}>
              carregando...
            </div>
            <div className="spinner"></div>
          </div>
        ) : (
          <div>
            {/* Tabela de dados */}
            <div style={{ maxWidth: "100%", overflowX: "auto" }}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  marginTop: "20px",
                  textAlign: "left",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#f4f4f4", textAlign: "center" }}>
                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>Pedido/Nota</th>
                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>Data/Hora</th>
                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>Consumidor</th>
                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>Valor (R$)</th>
                    <th style={{ padding: "10px", border: "1px solid #ddd" }}>Vendedor</th> {/* NOVA COLUNA */}
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => (
                    <tr key={index}>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        {item?.identificador || item?.numeroDocFiscal || "-"}
                      </td>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        {item.dataHoraAbertura ? new Date(item.dataHoraAbertura).toLocaleString("pt-BR") : "-"}
                      </td>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        {item.cpf || "-"}
                      </td>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        {`R$ ${parseFloat(item.valorTotalLiquido || 0).toFixed(2).replace(".", ",")}`}
                      </td>
                      <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>
                        {item.nomeVendedor || item.idVendedor || "Não informado"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Controles de paginação */}
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <button
                style={{
                  padding: "8px 16px",
                  margin: "0 10px",
                  backgroundColor: currentPage === 0 ? "#ccc" : "black",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: currentPage === 0 ? "not-allowed" : "pointer",
                }}
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 0}
              >
                Anterior
              </button>
              
              <span style={{ margin: "0 10px", fontWeight: "bold" }}>
                Página {currentPage + 1} de {totalPages}
              </span>
              
              <button
                style={{
                  padding: "8px 16px",
                  margin: "0 10px",
                  backgroundColor: currentPage >= totalPages - 1 ? "#ccc" : "black",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: currentPage >= totalPages - 1 ? "not-allowed" : "pointer",
                }}
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage >= totalPages - 1}
              >
                Próxima
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RelatorioVendedor;